// src/pages/user/profile/Profile.jsx
import React, { useContext, useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Modal, Nav } from 'react-bootstrap';
import {
  MdEdit, MdCamera, MdSave, MdCancel,
  MdPerson, MdNotifications
} from 'react-icons/md';
import UserMasterLayout from '../../../layout/useradmin/UserMasterLayout.js';
import '../../../assets/css/useradmin/profile/Profile.css';
import AppContext from '../../../context/AppContext.js';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Profile = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();

  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [phonenumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const [image, setImage] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [isEditing, setIsEditing] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [activeTab, setActiveTab] = useState('personal');
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const avatarInputRef = useRef(null);

  // ── Notifications ─────────────────────────────────────────────────────────
  const [notifications, setNotifications] = useState({
    emailNotifications: true,
    inAppNotifications: false,
  });

  // ── Favorites (stats count only) ──────────────────────────────────────────
  const [favorites] = useState([
    { id: 1, name: 'John Deere Tractor 5050D', category: 'Tractor', price: 'Rs. 5,000/day' },
    { id: 2, name: 'Kubota Harvester M9540', category: 'Harvester', price: 'Rs. 8,000/day' },
    { id: 3, name: 'Rotavator RT-250', category: 'Rotavator', price: 'Rs. 2,500/day' },
    { id: 4, name: 'Seed Drill SD-150', category: 'Seed Drill', price: 'Rs. 1,500/day' },
    { id: 5, name: 'Water Pump WP-500', category: 'Water Pump', price: 'Rs. 800/day' },
  ]);

  // ── Fetch Profile ─────────────────────────────────────────────────────────
  const fetchcustomerProfile = () => {
    const token = localStorage.getItem('authToken');
    axios.get(`${baseUrl}/customer/profile/fetchcustomerProfile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          setFullname(response.data.customer.fullname);
          setEmail(response.data.customer.email);
          setPhoneNumber(response.data.customer.phonenumber);
          setAddress(response.data.customer.address);
          setImage(response.data.customer.image || '');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // fetch on mount
  useEffect(() => {
    fetchcustomerProfile();
  }, []);

  // ── Update Profile ────────────────────────────────────────────────────────
  const updatecustomerProfile = () => {
    const token = localStorage.getItem('authToken');
    const formData = new FormData();
    formData.append('fullname', fullname);
    formData.append('email', email);
    formData.append('phonenumber', phonenumber);
    formData.append('address', address);
    if (avatarFile) {
      formData.append('image', avatarFile);
    }

    axios
      .post(`${baseUrl}/customer/profile/updatecustomerProfile`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          fetchcustomerProfile();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith('image/')) {
      setAvatarFile(file);

      const reader = new FileReader();

      reader.onloadend = () => {
        setAvatarPreview(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleNotificationToggle = (name) => {
    setNotifications(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSaveProfile = () => {
    updatecustomerProfile();   // DB mein save hoga
    setIsEditing(false);
  };

  // ── Change Password ───────────────────────────────────────────────────────
  const ChangePassword = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      alert('Please fill all password fields!');
      return;
    }
    if (newPassword !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }

    const token = localStorage.getItem('authToken');
    const formData = new FormData();
    formData.append('currentPassword', currentPassword);
    formData.append('newPassword', newPassword);

    axios
      .post(`${baseUrl}/customer/profile/changePassword`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          alert('Password changed successfully!');
          setCurrentPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setShowPasswordModal(false);
        } else {
          alert(response.data.message || 'Failed to change password.');
        }
      })
      .catch((error) => {
        console.log(error);
        alert('Failed to change password.');
      });
  };

  const handleSaveNotifications = () => {
    alert('Notification preferences saved successfully!');
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <UserMasterLayout>
      <Container fluid className="profile-page">

        {/* ── Page Header ── */}
        <div className="page-header">
          <h2>My Profile</h2>
          <p>Manage your personal information</p>
        </div>

        <Row>
          {/* ── Left: Profile Card ── */}
          <Col lg={4} md={12}>
            <div className="profile-card">

              <div className="profile-avatar-section">

                <input
                  type="file"
                  accept="image/*"
                  ref={avatarInputRef}
                  onChange={handleAvatarUpload}
                  style={{ display: 'none' }}
                />

                <div className="profile-avatar-large">

                  <img
                    src={
                      avatarPreview
                        ? avatarPreview
                        : image
                          ? `${baseUrlForFile}/${image}`
                          : null
                    }
                    alt="profile"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '50%',
                      display: image || avatarPreview ? 'block' : 'none',
                    }}
                  />

                  {!image && !avatarPreview && (
                    <span>
                      {fullname ? fullname.charAt(0).toUpperCase() : '?'}
                    </span>
                  )}

                </div>

                <button
                  className="change-avatar-btn"
                  onClick={() => avatarInputRef.current.click()}
                >
                  <MdCamera /> Change Photo
                </button>

              </div>

              <div className="profile-info-summary">
                <h3>{fullname}</h3>
                <p className="email">{email}</p>
                <p className="phone">{phonenumber}</p>
              </div>

              {/* <div className="profile-stats">
                <div className="stat-item">
                  <span className="stat-value">12</span>
                  <span className="stat-label">Total Rentals</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">3</span>
                  <span className="stat-label">Active Rentals</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">{favorites.length}</span>
                  <span className="stat-label">Favorites</span>
                </div>
              </div> */}

              <button
                className="change-password-btn"
                onClick={() => setShowPasswordModal(true)}
              >
                Change Password
              </button>

            </div>
          </Col>

          {/* ── Right: Tabs Card ── */}
          <Col lg={8} md={12}>
            <div className="profile-details-card">

              {/* ── Tab Navigation ── */}
              <Nav variant="tabs" className="profile-tabs">
                <Nav.Item>
                  <Nav.Link
                    active={activeTab === 'personal'}
                    onClick={() => setActiveTab('personal')}
                    className="profile-tab-link"
                  >
                    <MdPerson /> Personal Info
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={activeTab === 'notifications'}
                    onClick={() => setActiveTab('notifications')}
                    className="profile-tab-link"
                  >
                    <MdNotifications /> Notifications
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              {/* ── Tab Content ── */}
              <div className="tab-content-wrapper">

                {/* ── Personal Info Tab ── */}
                {activeTab === 'personal' && (
                  <div className="tab-content-section">
                    <div className="card-header">
                      <h3>Personal Information</h3>
                      {!isEditing ? (
                        <button className="edit-btn" onClick={() => setIsEditing(true)}>
                          <MdEdit /> Edit Profile
                        </button>
                      ) : (
                        <div className="action-buttons">
                          <button className="cancel-btn" onClick={() => setIsEditing(false)}>
                            <MdCancel /> Cancel
                          </button>
                          <button className="save-btn" onClick={handleSaveProfile}>
                            <MdSave /> Save Changes
                          </button>
                        </div>
                      )}
                    </div>

                    <Form>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={fullname}
                              onChange={e => setFullname(e.target.value)}
                              disabled={!isEditing}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control
                              type="email"
                              value={email}
                              onChange={e => setEmail(e.target.value)}
                              disabled={!isEditing}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={phonenumber}
                              onChange={e => setPhoneNumber(e.target.value)}
                              disabled={!isEditing}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              as="textarea" rows={2}
                              value={address}
                              onChange={e => setAddress(e.target.value)}
                              disabled={!isEditing}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                )}

                {/* ── Notifications Tab ── */}
                {activeTab === 'notifications' && (
                  <div className="tab-content-section">
                    <div className="card-header">
                      <h3>Notification Preferences</h3>
                    </div>

                    <div className="notification-list">
                      <div className="notification-item">
                        <div className="notification-info">
                          <h4>Email Notifications</h4>
                          <p>Receive notifications via email</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.emailNotifications}
                          onChange={() => handleNotificationToggle('emailNotifications')}
                          className="notification-toggle"
                        />
                      </div>

                      <div className="notification-item">
                        <div className="notification-info">
                          <h4>In App Notifications</h4>
                          <p>Receive notifications inside the platform</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.inAppNotifications}
                          onChange={() => handleNotificationToggle('inAppNotifications')}
                          className="notification-toggle"
                        />
                      </div>
                    </div>

                    <button className="save-preferences-btn" onClick={handleSaveNotifications}>
                      <MdSave /> Save Preferences
                    </button>
                  </div>
                )}

              </div>
            </div>
          </Col>
        </Row>

        {/* ── Change Password Modal ── */}
        <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Current Password</Form.Label>
                <Form.Control
                  type="password"
                  value={currentPassword}
                  onChange={e => setCurrentPassword(e.target.value)}
                  placeholder="Enter current password"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button className="modal-cancel-btn" onClick={() => setShowPasswordModal(false)}>
              Cancel
            </button>
            <button className="modal-confirm-btn" onClick={ChangePassword}>
              Change Password
            </button>
          </Modal.Footer>
        </Modal>

      </Container>
    </UserMasterLayout>
  );
};

export default Profile;